export const hmplusLimitedReleaseDetailConstants = {
  HMPLUS_LIMITED_RELEASE_DETAIL_LOADING:
    "HMPLUS_LIMITED_RELEASE_DETAIL_LOADING",
  HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS:
    "HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS",
  HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE:
    "HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const createHMplusLimitedReleaseDetailConstants = {
  CREATE_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING:
    "CREATE_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING",
  CREATE_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS:
    "CREATE_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS",
  CREATE_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE:
    "CREATE_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const editHMplusLimitedReleaseDetailConstants = {
  EDIT_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING:
    "EDIT_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING",
  EDIT_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS:
    "EDIT_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS",
  EDIT_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE:
    "EDIT_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const deleteHMplusLimitedReleaseDetailConstants = {
  DELETE_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING:
    "DELETE_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING",
  DELETE_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS:
    "DELETE_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS",
  DELETE_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE:
    "DELETE_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const addTargetHMplusLimitedReleaseDetailConstants = {
  ADD_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING:
    "ADD_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING",
  ADD_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS:
    "ADD_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS",
  ADD_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE:
    "ADD_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const removeTargetHMplusLimitedReleaseDetailConstants = {
  REMOVE_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING:
    "REMOVE_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING",
  REMOVE_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS:
    "REMOVE_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS",
  REMOVE_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE:
    "REMOVE_TARGET_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const activateHMplusLimitedReleaseDetailConstants = {
  ACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING:
    "ACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING",
  ACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS:
    "ACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS",
  ACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE:
    "ACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const deactivateHMplusLimitedReleaseDetailConstants = {
  DEACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING:
    "DEACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_LOADING",
  DEACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS:
    "DEACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_SUCCESS",
  DEACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE:
    "DEACTIVATE_HMPLUS_LIMITED_RELEASE_DETAIL_FAILURE",
};
